import { MutationTree } from 'vuex';
import {HolidaysState} from '.';
import {
	SET_HOLIDAYS,
	ADD_TO_HOLIDAYS_CACHE,
	REMOVE_HOLIDAY_FROM_CACHE,
	UPDATE_HOLIDAY_IN_CACHE,
	CLEAR_HOLIDAYS_CACHE
} from './mutationTypes';
import {HolidayViewModel} from '@/features/bots/models/holidayViewModel';

export const mutations: MutationTree<HolidaysState> = {
	[SET_HOLIDAYS](state, holidays: HolidayViewModel[]) {
		state.holidays = holidays;
	},

	[ADD_TO_HOLIDAYS_CACHE](state, holiday: HolidayViewModel) {
		state.holidays.push(holiday);
		state.holidays.sort((h1, h2) => h1.name.toLowerCase().localeCompare(h2.name.toLowerCase()));
	},

	[UPDATE_HOLIDAY_IN_CACHE](state, updatedHoliday: HolidayViewModel) {
		const holidayInCache = state.holidays.find(holiday => holiday.id === updatedHoliday.id);
		if (holidayInCache) {
			Object.assign(holidayInCache, updatedHoliday);
		}
		state.holidays.sort((h1, h2) => h1.name.toLowerCase().localeCompare(h2.name.toLowerCase()));
	},

	[REMOVE_HOLIDAY_FROM_CACHE](state, holidayId: string) {
		state.holidays = state.holidays.filter(holiday => holiday.id !== holidayId);
	},

	[CLEAR_HOLIDAYS_CACHE](state) {
		state.holidays = [];
	},
};
